/* tslint:disable */

declare var Object: any;
export interface ImageInterface {
  "pageDes"?: string;
  "pageTitle"?: string;
  "pageKeyWords"?: string;
  "canoLink"?: string;
  "title"?: string;
  "url"?: string;
  "thumbnail"?: string;
  "background"?: string;
  "headerImg"?: string;
  "content"?: string;
  "categories"?: string;
  "active"?: boolean;
  "position"?: number;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class Image implements ImageInterface {
  "pageDes": string;
  "pageTitle": string;
  "pageKeyWords": string;
  "canoLink": string;
  "title": string;
  "url": string;
  "thumbnail": string;
  "background": string;
  "headerImg": string;
  "content": string;
  "categories": string;
  "active": boolean;
  "position": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: ImageInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Image`.
   */
  public static getModelName() {
    return "Image";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Image for dynamic purposes.
  **/
  public static factory(data: ImageInterface): Image{
    return new Image(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Image',
      plural: 'Images',
      path: 'Images',
      idName: 'id',
      properties: {
        "pageDes": {
          name: 'pageDes',
          type: 'string'
        },
        "pageTitle": {
          name: 'pageTitle',
          type: 'string'
        },
        "pageKeyWords": {
          name: 'pageKeyWords',
          type: 'string'
        },
        "canoLink": {
          name: 'canoLink',
          type: 'string'
        },
        "title": {
          name: 'title',
          type: 'string'
        },
        "url": {
          name: 'url',
          type: 'string'
        },
        "thumbnail": {
          name: 'thumbnail',
          type: 'string'
        },
        "background": {
          name: 'background',
          type: 'string'
        },
        "headerImg": {
          name: 'headerImg',
          type: 'string'
        },
        "content": {
          name: 'content',
          type: 'string'
        },
        "categories": {
          name: 'categories',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "position": {
          name: 'position',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
